import { z } from 'zod';

export const FORM_SCHEMA = z
  .object({
    currentPassword: z.string().min(1, 'Required'),
    newPassword: z.string().min(1, 'Required'),
    confirmNewPassword: z.string().min(1, 'Required')
  })
  .refine(
    ({ newPassword, confirmNewPassword }) => confirmNewPassword === newPassword,
    { message: 'Passwords must match', path: ['confirmNewPassword'] }
  );
